import axios from 'axios'

const API_PATH = 'api/v2/admins/customers'

const CustomerCartsApiV2 = {

  /**
   * Get list of cart itmes of a particular customer
   * Invoke `GET api/v2/admins/carts/index
   * @param {string} customerId - Customer id string/number
   */
  get: async (customerId) => {
    const path = `${API_PATH}/${customerId}/carts`

    const response = axios.get(path, {})
    return response
  },
  /**
   * Add Item of Customer Carts
   * Invoke `POST api/v2/admins/customers/carts/add_item
   * @param {object} cart_item_values - Cart Item Value attributes
   * @param {string} customerId - Customer id string/number
   */
  add_item: async (checkoutCartFormValues) => {
    const path     = `${API_PATH}/${checkoutCartFormValues.customer.id}/carts/add_item`
    const params   = {
      customer_id          : checkoutCartFormValues.customer.id,
      product_id           : checkoutCartFormValues.product.id,
      product_dimension_id : checkoutCartFormValues.product_dimension_id,
      quantity             : 1
    }
    const response = axios.post(path, params)
    return response
  },
  /**
   * Remove Item of Customer Carts
   * Invoke `DELETE api/v2/admins/customers/carts/remove_item
   * @param {string} cartItemIds - Array of Cart Item Id string
   * @param {string} customerId - Customer id string/number
   */
  remove_item: async (customerId, cartItemIds) => {
    const path = `${API_PATH}/${customerId}/carts/remove_item`

    const payload = {
      cart_item_ids: cartItemIds
    }

    const response = axios.delete(path, { data: payload })
    return response
  }

}

export default CustomerCartsApiV2
